import * as _ from "lodash";

import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { GameGroupConfiguration } from "./editingConfiguration.reducer";
import { SelectedGroupsByProgressive } from "../models/SelectedGroupsByProgressive";

export interface GameGroupState {
    gameGroups: GameGroupConfiguration[];
    selected: SelectedGroupsByProgressive;
}

const initialState: GameGroupState = {
    gameGroups: [],
    selected: {
        progressive: [],
        /*proportional: [],
        normal: [],
        levels: [],
        multipots: [],
        easylink: [],
        sap: [],*/
        mr_champion: [],
        pig_boom: []
    }
};

export function gameGroupsReducer(
    state: GameGroupState = initialState,
    action: Action
): GameGroupState {
    let newState: GameGroupState;
    switch (action.type) {
        case ConfigurationsActionTypes.CLEAR_CONFIGURATION:
            return initialState;
        case ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG:
            newState = _.cloneDeep(state);
            if (
                (!action.payload.type ||
                action.payload.type == "Game_Group") &&
                (newState.gameGroups.length !== 0 ||
                    action.payload.config.length !== 0)
            ) {
                newState.gameGroups = action.payload.config;
                return newState;
            }
            return state;
        case ConfigurationsActionTypes.SELECT_GROUP_TYPE:
            /*if ((action.payload.groupType = "games")) {
                return initialState;
            }
            newState = _.cloneDeep(state);*/
            return state; //initialState;
        case ConfigurationsActionTypes.UPDATE_GROUPS_BASED_ON_GAME_TYPES:
            const { newGroupsState } = action.payload;
            return newGroupsState;
        case ConfigurationsActionTypes.UPDATE_PROGRESSIVES_CONFIG:
        case ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG:
            newState = _.cloneDeep(state);
            if (action.payload.groupType === "game") {
                newState.selected = action.payload.config.reduce(
                    (acc, curr) => {
                        let { game_groups: newlySelectedGroups, type } = curr;
                        if (
                            type == "multipots" ||
                            type == "jumbolink" ||
                            type == "luckytokenslink" ||
                            type == "reelstrike" ||
                            type == "levels" ||
                            type == "easylink" ||
                            type == "sap"
                        ) {
                            newlySelectedGroups = [];
                            curr.children.forEach(child => {
                                if (child.game_groups != undefined) {
                                    newlySelectedGroups =
                                        newlySelectedGroups.concat(
                                            child.game_groups
                                        );
                                }
                            });
                        }
                        let gameGroup: GameGroupConfiguration;

                        newlySelectedGroups.forEach(
                            (newlySelectedGroup: string) => {
                                gameGroup = findGameGroupById(
                                    newState,
                                    newlySelectedGroup
                                );
                                let typeKey =
                                    type == "fractionated" ||
                                    type == "multipots" ||
                                    type == "jumbolink" ||
                                    type == "luckytokenslink" ||
                                    type == "levels" ||
                                    type == "reelstrike" ||
                                    type == "easylink" ||
                                    type == "sap" ||
                                    type == "normal" ||
                                    type == "proportional"
                                        ? "progressive"
                                        : type;
                                acc[typeKey].push(gameGroup);
                            }
                        );
                        return acc;
                    },
                    {
                        progressive: [],
                        /*proportional: [],
                        normal: [],
                        levels: [],
                        multipots: [],
                        easylink: [],
                        sap: [],*/
                        mr_champion: [],
                        pig_boom: []
                    }
                );
            }
            return newState;
        case ConfigurationsActionTypes.CLEAN_GROUP_TYPES:
            if (action.payload.selectedType == "terminal") {
                return {
                    ...initialState,
                    gameGroups: state.gameGroups
                };
            } else if (state.gameGroups.length > 0) {
                // Clean non-existant from selected
                newState = _.cloneDeep(state);
                Object.keys(state.selected).map(key => {
                    if (state.selected[key].length > 0) {
                        let newSelected = state.selected[key].filter(
                            selectedGroup => {
                                return !state.gameGroups.includes(selectedGroup)
                                    ? false
                                    : true;
                            }
                        );
                        newState.selected[key] = newSelected;
                    }
                });
                return newState;
            }
        default:
            return state;
    }
}

/**
 * Auxiliary function that returns the GameGroupConfiguration object that
 * matches the description provided.
 * @param state { GameGroupState }
 * @param id { string }
 * @returns GameGroupConfiguration
 */
function findGameGroupById(
    state: GameGroupState,
    id: string
): GameGroupConfiguration {
    return state.gameGroups.find(group => group.id == id);
}
